import { Image } from '../types';

export const imageData: Image[] = [


  // Live Category
  {
    id: 1,
    url: '/images/Live/Drum_Head.jpg',
    alt: 'Drum Head',
    title: 'Drum Head',
    category: 'Live'
  },
  {
    id: 7,
    url: '/images/Live/1303320322774673774.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 8,
    url: '/images/Live/2110461439346330016.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 9,
    url: '/images/Live/2158495823392611238.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 10,
    url: '/images/Live/3271607453237272389.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 11,
    url: '/images/Live/3379727613270785995.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 12,
    url: '/images/Live/3717761873440524608.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 13,
    url: '/images/Live/406852329691132561.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 14,
    url: '/images/Live/41169457633935931.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 15,
    url: '/images/Live/4242590947708936369.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 16,
    url: '/images/Live/4510278734258530197.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 17,
    url: '/images/Live/4656237890631627797.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 18,
    url: '/images/Live/4900640980728586143.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 19,
    url: '/images/Live/4930269266922497303.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 20,
    url: '/images/Live/4956593352674788511.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 21,
    url: '/images/Live/5171952083089963580.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 22,
    url: '/images/Live/6107424817673810249.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 23,
    url: '/images/Live/6155030797794823936.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 24,
    url: '/images/Live/6375913694292211994.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 25,
    url: '/images/Live/6384225390743970523.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 26,
    url: '/images/Live/6439189000707531956.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 27,
    url: '/images/Live/724202735133542912.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 28,
    url: '/images/Live/7583778687777893287.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 29,
    url: '/images/Live/8195709874067604655.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 30,
    url: '/images/Live/8205159972966567616.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 31,
    url: '/images/Live/8208572360713822787.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 32,
    url: '/images/Live/8319149233834989036.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 33,
    url: '/images/Live/9133919477380750509.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 34,
    url: '/images/Live/9165551436646397613.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 35,
    url: '/images/Live/IMG_0340.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 36,
    url: '/images/Live/IMG_0350.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 37,
    url: '/images/Live/IMG_0351.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 38,
    url: '/images/Live/IMG_4988.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 39,
    url: '/images/Live/IMG_4989.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 40,
    url: '/images/Live/IMG_4990.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 41,
    url: '/images/Live/IMG_6196.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 42,
    url: '/images/Live/IMG_6197.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 43,
    url: '/images/Live/IMG_6198.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 44,
    url: '/images/Live/IMG_6199.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 45,
    url: '/images/Live/IMG_6200.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 46,
    url: '/images/Live/IMG_6201.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 47,
    url: '/images/Live/IMG_6202.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 48,
    url: '/images/Live/IMG_6203.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 49,
    url: '/images/Live/IMG_6205.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 50,
    url: '/images/Live/IMG_6206.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 51,
    url: '/images/Live/IMG_6207.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 52,
    url: '/images/Live/IMG_6208.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 53,
    url: '/images/Live/IMG_6209.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 54,
    url: '/images/Live/IMG_6212.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 55,
    url: '/images/Live/IMG_6213.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 56,
    url: '/images/Live/IMG_6214.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 57,
    url: '/images/Live/IMG_6216.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 58,
    url: '/images/Live/IMG_6222.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 59,
    url: '/images/Live/IMG_6223.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 60,
    url: '/images/Live/IMG_6224.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 61,
    url: '/images/Live/IMG_6230.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 62,
    url: '/images/Live/IMG_6231 (1).jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 63,
    url: '/images/Live/IMG_6231.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },
  {
    id: 64,
    url: '/images/Live/IMG_6233.jpeg',
    alt: 'Live Performance Photo',
    title: 'Live Performance Photo',
    category: 'Live'
  },

  // Art and Logos Category
  {
    id: 2,
    url: '/images/Art_and_Logos/Abandoned_Radio_Tower.jpg',
    alt: 'Abandoned Radio Tower',
    title: 'Abandoned Radio Tower',
    category: 'Art and Logos'
  },
  {
    id: 3,
    url: '/images/Art_and_Logos/Logo_Only_(White).png',
    alt: 'Logo Only (White)',
    title: 'Logo Only (White)',
    category: 'Art and Logos'
  },
  {
    id: 4,
    url: '/images/Art_and_Logos/Logo_Text_Only_(White).png',
    alt: 'Logo Text Only (White)',
    title: 'Logo Text Only (White)',
    category: 'Art and Logos'
  },
  {
    id: 5,
    url: '/images/Art_and_Logos/Logo_with_Background_(Black).png',
    alt: 'Logo with Background (Black)',
    title: 'Logo with Background (Black)',
    category: 'Art and Logos'
  },
  {
    id: 6,
    url: '/images/Art_and_Logos/Logo.png',
    alt: 'Logo',
    title: 'Logo',
    category: 'Art and Logos'
  }

];
